<template>
	<div class="home view">
		<div class="header">
			<h2>Profile</h2>
		</div>

		<div class="columns">
			<div>
				<label for="first_name">First name *</label>
				<input id="first_name" v-model="user.firstName" type="text" autocomplete="off" />
			</div>

			<div>
				<label for="last_name">Last name *</label>
				<input id="last_name" v-model="user.lastName" type="text" autocomplete="off" />
			</div>
		</div>

		<div class="columns">
			<div>
				<label for="new-password">New password</label>
				<input id="new-password" v-model="user.password" type="password" autocomplete="off" />
			</div>

			<div>
				<label for="confirm-password">Confirm new password</label>
				<input id="confirm-password" v-model="confirmPassword" type="password" autocomplete="off" />
			</div>
		</div>

		<div class="actions">
			<BaseButton @click="saveChanges">
				Save changes
			</BaseButton>
		</div>

		<NoticeArea />
	</div>
</template>

<script>
	import NoticeArea from '../components/NoticeArea';
	import BaseButton from '../components/BaseButton';
	import Backend from '../inc/backend';
	import Bus from '../inc/bus';
	import Store from '../inc/store';

	export default {
		components: {
			NoticeArea,
			BaseButton
		},
		data() {
			return {
				confirmPassword: ''
			};
		},
		computed: {
			userId() {
				return Store.user.id;
			},
			user() {
				return Store.user;
			}
		},
		methods: {
			saveChanges() {
				if(!this.user.firstName || !this.user.lastName) {
					Bus.emit('error', 'First and last name is required.');

					return;
				}

				if(this.user.password) {
					if(this.user.password !== this.confirmPassword) {
						Bus.emit('error', 'The passwords you enter do not match. Please try again.');

						return;
					}

					if(this.user.password.length < 8) {
						Bus.emit('error', 'Password must be at least 8 characters.');

						return;
					}
				}

				Backend.put('users/' + this.userId, this.user)
					.then(() => Bus.emit('success', 'Changes saved!'));
			}
		}
	};
</script>

<style lang="scss" scoped>
	.home.view {
		width: 100%;
		max-width: 1360px;
		margin: 0 auto;

		& > .notices {
			position: absolute;
			bottom: 60px;
			left: 60px;
			list-style-type: none;
			z-index: 1000;
		}
	}

	.header::v-deep {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		column-gap: $default_padding;
		margin-bottom: $default_padding;

		button {
			line-height: 2em;
			padding: 0 12px;
		}

		h2 {
			margin-bottom: 0;
		}

		& > * {
			flex: 0 1 auto;
		}
	}

	.columns {
		display: flex;
		gap: $default_padding;
		margin-bottom: $default_padding;

		> * {
			flex: 1;
		}
	}

	.actions {
		display: flex;
		justify-content: flex-end;
	}
</style>